import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Send email signup data to BlueShift
export async function sendEmailSignup({ email, ip, firstname, lastname, debt, income }) {
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: ENDPOINTS.BLUESHIFT_DATA,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      email,
      ip,
      firstname,
      lastname,
      debt,
      income,
      faf: '1',
      seed: '0'
    })
  }

  try {
    const response = await axios.request(config)
    console.log('BlueShift data signup response:', response.data)
    return response.data
  } catch (error) {
    console.error('BlueShift data signup error:', error)
    return null
  }
}

// Send phone update to BlueShift
export async function sendPhoneUpdate({ email, phone, firstname, lastname, ip }) {
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: ENDPOINTS.BLUESHIFT_DATA,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      email,
      phone_number: '+1' + phone,
      firstname,
      lastname,
      ip,
      faf: '1',
      seed: '0'
    })
  }

  try {
    const response = await axios.request(config)
    console.log('BlueShift data phone update response:', response.data)
    return response.data
  } catch (error) {
    console.error('BlueShift data phone update error:', error)
    return null
  }
}

// Send address update to BlueShift
export async function sendAddressUpdate({ email, state, zip }) {
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: ENDPOINTS.BLUESHIFT_DATA,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      email,
      state,
      zip,
      faf: '1',
      seed: '0'
    })
  }

  try {
    const response = await axios.request(config)
    console.log('BlueShift data address update response:', response.data)
    return response.data
  } catch (error) {
    console.error('BlueShift data address update error:', error)
    return null
  }
}

// Send Array data to BlueShift
export async function sendArrayData({ email, arrayDebt, creditScore, collections, delinquencies, taxLiens, studentLoans, birthYear, birthMonth, birthDay }) {
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: ENDPOINTS.BLUESHIFT_DATA,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      email,
      arrayDebt,
      creditScore,
      collections,
      delinquencies,
      taxLiens,
      studentLoans,
      birthYear,
      birthMonth,
      birthDay
    })
  }

  try {
    const response = await axios.request(config)
    console.log('BlueShift data array response:', response.data)
    return response.data
  } catch (error) {
    console.error('BlueShift data array error:', error)
    return null
  }
}

// Send buyer info to BlueShift (after successful lead)
export async function sendBuyerInfo({ email, buyer, buyerPhone }) {
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: ENDPOINTS.BLUESHIFT_DATA,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      email,
      buyer,
      // != null: buyerPhone can also arrive undefined (advertiser DID unset).
      ...(buyerPhone != null ? { buyerPhone } : {}),
      faf: '1',
      seed: '0'
    }
  }

  try {
    const response = await axios.request(config)
    console.log('BlueShift data buyer info response:', response.data)
    return response.data
  } catch (error) {
    console.error('BlueShift data buyer info error:', error)
    return null
  }
}

export const blueshiftDataService = {
  sendEmailSignup,
  sendPhoneUpdate,
  sendAddressUpdate,
  sendArrayData,
  sendBuyerInfo
}
